import './Home.scss';
import { ServiceType, MessagesCategoryType, UsersCategoryType, } from 'modules/analytics/models';
import moment from 'moment';
import culturesJson from 'modules/application/misc/cultures.json';
import timezonesJson from 'modules/application/misc/timezones.json';
import { HomeFeatures } from './HomeFeatures';
import { blipStoreStateName } from 'modules/blipStore';
import { blipStoreStateExtensionsDetail } from 'modules/blipStore';
import { BlipStoreFeatures } from 'modules/blipStore/BlipStoreFeatures';
import { isOnboardingCompletedOnLocalStorage } from './FirstStepsBotComponent/FirstStepsOnboardingConstants';
import { ApplicationType } from 'modules/application/create/CreateApplicationService';
import { HOME_ADD_TEAM_BUTTON_CLICKED, HOME_AI_BUTTON_CLICKED, HOME_CHANNEL_BUTTON_CLICKED, HOME_MESSAGE_RECEIVED_SHORTCUT_CLICKED, HOME_MESSAGE_SENT_SHORTCUT_CLICKED, HOME_PREFERENCES_APPLIED, HOME_USER_SHORTCUT_CLICKED, HOME_APPLICATION_OPENED, } from './HomeSegmentEvents';
import { teamStateName } from '../team';
import { userStateName } from '../users';
import { artificialIntelligenceStateName } from '../ai';
import { dashboardGeneralStateName } from '../analytics';
import { AppCuesEvents, AppCuesService } from 'modules/shared/AppCuesService';
import { homeName } from '.';
import { HomeConstants } from './homeConstants';
import { removeSpecialCharacter } from 'modules/shared/validators/ApplicationNameValidation';
import { whatsAppEmbeddedStateName } from '../channels';
import { ConfigurationFeatures } from '../configurations/ConfigurationFeatures';
import { ContractActivationOrigins } from '../portal-submodule-builder/templates/builder/studio/services/StudioSegmentService';
const BLIP_STORE_PARAMETER_BOT_HOME_JOURNEY = 'BotHome';
const BLIP_STORE_INDICATED_VIEW_ALL_CLICKED_TRACKING = 'home-indicated-extensions-view-all-clicked';
const BLIP_STORE_INDICATED_EXTENSION_CLICKED_TRACKING = 'home-indicated-extensions-clicked';
export class HomeController {
    static $inject = ['$state', '$window', 'application', 'ApplicationService2', 'ConfigurationsService', 'ExternalBlipStoreService', 'AnalyticsServiceFactory', 'LoadingService', '$translate', 'MessagingHubService', 'PermissionsService', 'AdminService', 'BLIP_DOMAIN', 'ChannelsService', 'APPLICATION_DEFAULT_IMAGE', 'SharedToastsService', 'BlipToastService', 'CallerConfigurationService', 'SegmentService', '$location', 'TranslateService', 'MEDIA_PROFILE_FOR_AVATARS', 'StudioService'];
    constructor($state, $window, application, ApplicationService2, ConfigurationsService, ExternalBlipStoreService, AnalyticsServiceFactory, LoadingService, $translate, MessagingHubService, PermissionsService, AdminService, BLIP_DOMAIN, ChannelsService, APPLICATION_DEFAULT_IMAGE, SharedToastsService, BlipToastService, CallerConfigurationService, SegmentService, $location, TranslateService, MEDIA_PROFILE_FOR_AVATARS, StudioService) {
        'ngInject';
        this.$state = $state;
        this.$window = $window;
        this.application = application;
        this.ApplicationService2 = ApplicationService2;
        this.ConfigurationsService = ConfigurationsService;
        this.ExternalBlipStoreService = ExternalBlipStoreService;
        this.AnalyticsServiceFactory = AnalyticsServiceFactory;
        this.LoadingService = LoadingService;
        this.$translate = $translate;
        this.MessagingHubService = MessagingHubService;
        this.PermissionsService = PermissionsService;
        this.AdminService = AdminService;
        this.BLIP_DOMAIN = BLIP_DOMAIN;
        this.ChannelsService = ChannelsService;
        this.APPLICATION_DEFAULT_IMAGE = APPLICATION_DEFAULT_IMAGE;
        this.SharedToastsService = SharedToastsService;
        this.BlipToastService = BlipToastService;
        this.CallerConfigurationService = CallerConfigurationService;
        this.SegmentService = SegmentService;
        this.$location = $location;
        this.TranslateService = TranslateService;
        this.MEDIA_PROFILE_FOR_AVATARS = MEDIA_PROFILE_FOR_AVATARS;
        this.StudioService = StudioService;
        this.cultureHandler = { touched: false, invalid: false };
        this.timezoneHandler = { touched: false, invalid: false };
        this.isPreferencesValid = false;
        this.isLoading = {
            users: true,
            messages: true,
            teamMembers: true,
        };
        this.teamMembers = [];
        this.isEditing = false;
        this.isEditingName = false;
        this.culturesOld = Object.keys(culturesJson).map((key) => ({ key, name: culturesJson[key].name }));
        this.cultures = Object.keys(culturesJson).map((key) => ({ value: key, label: culturesJson[key].name }));
        this.timezonesOld = timezonesJson.timezones.map((zone) => ({ key: zone.value, name: zone.text }));
        this.timezones = timezonesJson.timezones.map((zone) => ({ value: zone.value, label: zone.text }));
        this.enableMauConcept = false;
        this.isOnboardingEnabled = false;
        this.isChatbotHomeOnboardingEnabled = false;
        this.hasHeadstartPlugin = false;
        this.onboardingTemplate = '';
        this.isHidingHomeMetrics = false;
        this.onFinishEditingName = (event) => {
            if (event.detail?.value !== event.detail?.oldValue) {
                this.finishEditingName(event.detail.value.trim());
            }
        };
        this.onCultureChange = (event) => {
            if (this.cultureHandler.touched) {
                const newCulture = event.detail?.value;
                if (newCulture?.length > 0 && newCulture !== this.culture) {
                    this.cultureHandler.invalid = false;
                    this.culture.key = newCulture;
                }
                else {
                    this.cultureHandler.invalid = true;
                }
                this.setPreferencesValidity();
            }
        };
        this.onTimezoneChange = (event) => {
            if (this.timezoneHandler.touched) {
                const newTimezone = event.detail?.value;
                if (newTimezone?.length > 0 && newTimezone !== this.timezone) {
                    this.timezoneHandler.invalid = false;
                    this.timezone.key = newTimezone;
                }
                else {
                    this.timezoneHandler.invalid = true;
                }
                this.setPreferencesValidity();
            }
        };
        this.onCultureFocus = () => {
            if (!this.cultureHandler.touched) {
                this.cultureHandler.touched = true;
            }
        };
        this.onTimezoneFocus = () => {
            if (!this.timezoneHandler.touched) {
                this.timezoneHandler.touched = true;
            }
        };
    }
    async $onInit() {
        await this.ChannelsService.init(this.application);
        await this.verifyCustomAIRequestState();
        this.setup();
    }
    async verifyCustomAIRequestState() {
        const userAccount = await this.ApplicationService2.getAccount();
        if (typeof userAccount.extras != 'undefined' && typeof userAccount.extras.customAiResquestState) {
            this.customAiRequest = userAccount.extras.customAiResquestState;
        }
    }
    async setup() {
        this.createdAt = moment(this.application.created).format('L');
        const payload = {
            shortName: this.application.shortName,
            startDate: new Date(this.application.created).toISOString(),
            endDate: new Date().toISOString(),
        };
        await this.loadCultureAndTimezone();
        this.onboardingTemplate = this.getChatbotTemplate();
        await this.checkFeatures();
        this.registerHomeOpenedTracking();
        await this.registerAgentPlanTracking();
        this.hasHeadstartPlugin = await this.getConfiguration('postmaster@portal.blip.ai', 'Plugins');
        this.subscribeToAppCuesEvents();
        this.editingApplication = this.application;
        this.checkEditPermissions();
        this.checkPermissions();
        if (!this.isHidingHomeMetrics) {
            this.loadUsers(payload);
            this.loadMessages(payload);
        }
        this.loadTeamMembers();
        this.loadClusterConfigurations();
        await this.checkChannels();
        if (this.isBlipStoreHomeBotPluginsRecommendationServicePageEnabled) {
            const language = await this.TranslateService.getCurrentLanguage();
            await this.GetExtensionsByParameter(language);
        }
    }
    async checkFeatures() {
        this.isShowChatbotClusterEnabled = await HomeFeatures.isShowChatbotClusterEnabled();
        this.isCustomAIExperimentEnabled = await HomeFeatures.isCustomAIExperimentEnabled();
        this.isHidingHomeMetrics = await HomeFeatures.isHideHomeMetricsEnabled();
        this.isBlipStoreHomeBotPluginsRecommendationServicePageEnabled = await BlipStoreFeatures.isBlipStoreHomeBotPluginsRecommendationServicePageEnabled();
        this.isConfigurationsApplicationGetEnabled = await ConfigurationFeatures.isConfigurationDomainOnAdvancedConfigurationPropertiesGetEnabled();
        await this.isOnboardingFeatureEnabled();
    }
    async isOnboardingFeatureEnabled() {
        const isOnboardingFeatureToggleEnabled = await HomeFeatures.isOnboardingEnabled() && await HomeFeatures.isOnboardingTrackingsEnabled();
        this.isOnboardingEnabled = !isOnboardingCompletedOnLocalStorage() &&
            isOnboardingFeatureToggleEnabled && this.application.template === ApplicationType.Builder;
    }
    async getConfiguration(domain, key) {
        const configs = await this.CallerConfigurationService.getWithDomainOwner(this.application.shortName + '@msging.net', domain, this.isConfigurationsApplicationGetEnabled);
        return configs.items.find(item => item.owner == domain && item.name == key);
    }
    getChatbotTemplate() {
        const id = this.account.extras['#marketplace.id'];
        switch (true) {
            case /marketplace_.*/.test(id):
                return 'marketplace';
            case /blip_deskCustomerService/.test(id):
                return 'helpdesk';
            default:
                return 'scratch';
        }
    }
    async checkEditPermissions() {
        this.hasEditPermission = await this.PermissionsService.hasPermissions('write', 'basicConfigurations');
    }
    async fileUploaded(file) {
        try {
            if (!file) {
                throw 'error';
            }
            this.LoadingService.startLoading();
            const mediaUri = await this.ApplicationService2.uploadFile(file, { profile: this.MEDIA_PROFILE_FOR_AVATARS });
            this.editingApplication.imageUri = mediaUri;
            await this.save();
        }
        catch (err) {
            console.error(err);
            this.SharedToastsService.showUploadErrorToast(err.status);
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    validateSpecialCharacter(event) {
        const withoutSpecialCharacter = removeSpecialCharacter(event.detail.value);
        event.target.value = withoutSpecialCharacter;
    }
    async save() {
        const account = await this.MessagingHubService.sendCommand({
            method: 'get',
            uri: '/account',
        });
        const newAccount = {
            ...account,
            fullName: this.editingApplication.name,
            photoUri: this.editingApplication.imageUri,
        };
        await this.MessagingHubService.sendCommand({
            method: 'set',
            type: 'application/vnd.lime.account+json',
            uri: '/account',
            resource: newAccount,
        });
        const successMsg7 = await this.$translate('utils.successMsg.7');
        this.BlipToastService.show('success', { msg: successMsg7 });
        this.$state.reload();
    }
    async goToChannel(channel) {
        if (!this.permissions.channels) {
            const errorMsg74 = await this.$translate('utils.errorMsg.74');
            this.BlipToastService.show('danger', { msg: errorMsg74 });
            return;
        }
        if (channel === 'whatsapp') {
            this.$state.go(whatsAppEmbeddedStateName);
            return;
        }
        this.$state.go(`auth.application.detail.channels.${channel}`);
    }
    async startEditingName() {
        this.isEditingName = true;
        this.editingApplication = this.application;
    }
    cancelEditingName() {
        this.editingApplication = this.application;
        this.isEditingName = false;
    }
    async finishEditingName(newApplicationName) {
        this.editingApplication.name = removeSpecialCharacter(newApplicationName) ?? removeSpecialCharacter(this.editingApplication.name);
        if (this.editingApplication.name.length > 0) {
            try {
                this.LoadingService.startLoading();
                this.application = this.editingApplication;
                await this.save();
                this.SegmentService.createOrganizationTrack(HOME_PREFERENCES_APPLIED);
            }
            catch (error) {
                console.error(error);
            }
            finally {
                this.isEditingName = false;
                this.LoadingService.stopLoading();
            }
        }
    }
    cancelEditing() {
        this.loadCultureAndTimezone();
        this.isEditing = false;
    }
    async finishEditing() {
        try {
            this.LoadingService.startLoading();
            if (this.culture && this.timezone) {
                this.account.culture = this.culture.key;
                this.account.timezoneName = this.timezone.key;
                await this.ApplicationService2.setAccount(this.account);
                this.isEditing = false;
            }
            const message = await this.$translate('applicationDetail.home.preferencesToast.success');
            this.BlipToastService.show('success', { msg: message });
            this.SegmentService.createOrganizationTrack(HOME_PREFERENCES_APPLIED);
            this.isPreferencesValid = false;
        }
        catch (error) {
            console.error(error);
            const message = await this.$translate('applicationDetail.home.preferencesToast.failure');
            this.BlipToastService.show('danger', { msg: message });
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async startEditing() {
        this.isEditing = true;
    }
    checkPermissions() {
        this.permissions = this.application.applicationUserPermissionModel.reduce((array, perm) => {
            switch (perm.permissionClaim) {
                case 105:
                    return {
                        ...array,
                        channels: perm.permissionAction > 0,
                    };
                case 107:
                    return { ...array, users: perm.permissionAction > 0 };
                case 112:
                    return { ...array, team: perm.permissionAction > 0 };
                case 115:
                    return {
                        ...array,
                        analytics: perm.permissionAction > 0,
                    };
                default:
                    return { ...array };
            }
        }, {});
    }
    async checkChannels() {
        this.ChannelsService.setChannelsActivationStatuses();
        await this.ChannelsService.setChannelsDeploymentStatuses();
    }
    async loadTeamMembers() {
        try {
            const applicationUsers = await this.ApplicationService2.getUsersAccounts(this.application);
            this.teamMembers = applicationUsers.map((res) => {
                const identityEmail = decodeURIComponent(res.user.identity.replace(`@${this.BLIP_DOMAIN}`, ''));
                return {
                    email: res.user.email || identityEmail,
                    fullName: res.user.fullName || identityEmail,
                    photoUri: res.user.photoUri,
                    tooltipName: res.user.fullName || identityEmail,
                };
            });
            if (this.teamMembers.length > 7) {
                const fullLength = this.teamMembers.length;
                this.teamMembers = this.teamMembers.slice(0, 7);
                this.teamMembers = this.teamMembers.concat({
                    fullName: `+ ${fullLength - 7 > 9 ? 9 : fullLength - 7}`,
                });
            }
        }
        catch (err) {
            console.error(err);
        }
        finally {
            this.isLoading.teamMembers = false;
        }
    }
    async loadCultureAndTimezone() {
        this.account = await this.ApplicationService2.getAccount();
        this.culture = await this.ConfigurationsService.loadCulture(this.account);
        this.timezone = this.ConfigurationsService.loadTimezones(this.account);
    }
    async loadClusterConfigurations() {
        if (this.isShowChatbotClusterEnabled) {
            this.clusterConfigurations = await this.AdminService.get(this.application, this.isConfigurationsApplicationGetEnabled);
        }
    }
    async loadUsers(payload) {
        try {
            const Service = this.AnalyticsServiceFactory.createService(ServiceType.Users);
            const { endDate, ...rest } = payload;
            let category = UsersCategoryType.UniqueUsers;
            if (this.enableMauConcept) {
                category = UsersCategoryType.EngagedUsers;
            }
            const data = await Service.getActionsForCategory({
                ...rest,
                endDate,
                category: category,
                application: this.application,
            });
            this.nUsers = data ? this.processNumber(data[0].count) : '-';
        }
        catch (err) {
            console.error(err);
        }
        finally {
            this.isLoading.users = false;
        }
    }
    async loadMessages(payload) {
        try {
            const Service = this.AnalyticsServiceFactory.createService(ServiceType.Messages);
            this.receivedMessages = await this.getMessages(Service, payload, MessagesCategoryType.ReceivedMessages);
            this.sentMessages = await this.getMessages(Service, payload, MessagesCategoryType.SentMessages);
        }
        catch (err) {
            console.error(err);
        }
        finally {
            this.isLoading.messages = false;
        }
    }
    async getMessages(service, payload, category) {
        const data = await service.getActionsForCategory({
            ...payload,
            category,
            application: this.application,
        });
        return this.processNumber(data.reduce((sum, d) => sum + d.count, 0));
    }
    processNumber(pNumber) {
        let final;
        switch (true) {
            case pNumber > 1000000:
                final =
                    '+' +
                        String(Math.floor(pNumber / 1000000) * 1000000)
                            .split('0')[0]
                            .concat('M');
                break;
            case pNumber > 100000:
                final =
                    '+' +
                        String(Math.floor(pNumber / 100000) * 100000)
                            .split('0')[0]
                            .concat('00K');
                break;
            case pNumber > 10000:
                final =
                    '+' +
                        String(Math.floor(pNumber / 10000) * 10000)
                            .split('0')[0]
                            .concat('0K');
                break;
            case pNumber > 1000:
                final =
                    '+' +
                        String(Math.floor(pNumber / 1000) * 1000)
                            .split('0')[0]
                            .concat('K');
                break;
            case pNumber > 100:
                final = '+' + String(Math.floor(pNumber / 100) * 100);
                break;
            case pNumber > 10:
                final = '+' + String(Math.floor(pNumber / 10) * 10);
                break;
            default:
                final = String(pNumber);
                break;
        }
        return final;
    }
    async subscribeToAppCuesEvents() {
        AppCuesService.instance.onEvent(AppCuesEvents.FlowCompleted, await this.$translate('onboardingChecklist.connectingChannels.appCuesId'), async () => {
            this.$window.sessionStorage.setItem(`${this.application.shortName}-connectingChannels`, HomeConstants.COMPLETED_STATUS);
            this.$state.go(homeName);
        });
    }
    setPreferencesValidity() {
        if (!this.timezoneHandler.touched && !this.cultureHandler.touched) {
            this.isPreferencesValid = false;
            return;
        }
        if (this.timezoneHandler.invalid || this.cultureHandler.invalid) {
            this.isPreferencesValid = false;
            return;
        }
        this.isPreferencesValid = true;
    }
    onAddChannelsClick() {
        this.SegmentService.createOrganizationTrack(HOME_CHANNEL_BUTTON_CLICKED);
    }
    onAddTeamClick() {
        this.$state.go(teamStateName);
        this.SegmentService.createOrganizationTrack(HOME_ADD_TEAM_BUTTON_CLICKED);
    }
    onViewMoreUsersClick() {
        this.$state.go(userStateName);
        this.SegmentService.createOrganizationTrack(HOME_USER_SHORTCUT_CLICKED);
    }
    onViewMoreReceivedMessagesClick() {
        this.$state.go(dashboardGeneralStateName);
        this.SegmentService.createOrganizationTrack(HOME_MESSAGE_RECEIVED_SHORTCUT_CLICKED);
    }
    onViewMoreSentMessagesClick() {
        this.$state.go(dashboardGeneralStateName);
        this.SegmentService.createOrganizationTrack(HOME_MESSAGE_SENT_SHORTCUT_CLICKED);
    }
    onAiClick() {
        this.$state.go(artificialIntelligenceStateName);
        this.SegmentService.createApplicationTrack({ trackEvent: HOME_AI_BUTTON_CLICKED });
    }
    get showAiCard() {
        return this.isCustomAIExperimentEnabled && this.customAiRequest != 'finished';
    }
    async GetExtensionsByParameter(language) {
        this.extensions = await this.ExternalBlipStoreService.GetExtensionsByParameter(this.application.tenantId, language, BLIP_STORE_PARAMETER_BOT_HOME_JOURNEY);
    }
    onOpenBlipStore() {
        this.SegmentService.createTrack(BLIP_STORE_INDICATED_VIEW_ALL_CLICKED_TRACKING);
        this.$state.go(blipStoreStateName);
        window.dispatchEvent(new CustomEvent('mfe-route-change', { detail: '/blip-store' }));
    }
    onOpenBlipStoreExtensionDetail(extensionId, extensionName) {
        this.SegmentService.createTrack(BLIP_STORE_INDICATED_EXTENSION_CLICKED_TRACKING, {
            extensionId: extensionId,
            extensionName: extensionName,
        });
        this.$state.go(blipStoreStateExtensionsDetail, { id: extensionId });
        window.dispatchEvent(new CustomEvent('mfe-route-change', { detail: '/blip-store' }));
    }
    registerHomeOpenedTracking() {
        this.SegmentService.createApplicationTrack({
            trackEvent: HOME_APPLICATION_OPENED,
            application: this.application,
        });
    }
    async registerAgentPlanTracking() {
        try {
            await this.StudioService.trackStudioActivation(ContractActivationOrigins.ApplicationHome);
        }
        catch (error) {
            console.error('(Studio) Failed to track studio activation:', error);
        }
    }
}
HomeController.$inject = ['$state', '$window', 'application', 'ApplicationService2', 'ConfigurationsService', 'ExternalBlipStoreService', 'AnalyticsServiceFactory', 'LoadingService', '$translate', 'MessagingHubService', 'PermissionsService', 'AdminService', 'BLIP_DOMAIN', 'ChannelsService', 'APPLICATION_DEFAULT_IMAGE', 'SharedToastsService', 'BlipToastService', 'CallerConfigurationService', 'SegmentService', '$location', 'TranslateService', 'MEDIA_PROFILE_FOR_AVATARS', 'StudioService'];
